export const LetPassAccountConstant = {
    SEARCH_CRITERIA: "Search Criteria",
    CATEGORY: "Payment",
    TITLE: "Let Pass Account",
    RECEIPT_NO: "Receipt No.",
    CC_COMPANY_CODE: "CC Company Code",
    TRANSACTION_DATE: "Transaction Date",
    TRANSACTION_DATE_RANGE: "Transaction Date Range",
    TRANSACTION_TYPE: "Transaction Type",
    PAYMENT_MODE: "Payment Mode",
    BANK_CODE: "Bank Code",
    PAY_ORDER_NO: "Pay Order No.",
    TRANSACTION_AMOUNT: "Transaction Amount",
    TRANSACTION_DESCRIPTION: "Transaction Description",
    COLLECTED_BY: "Collected By",
    ACTIVE_IND: "Active Ind.",
    DEPOSIT_BUT: "Deposit",
    ACCOUNT_OPEN_BUT: "Account Open",
    ACCOUNT_CLOSURE_BUT: "Account Closure",
    REPRINT_BUT: "Reprint",
    LPA_BALANCE: "LPA Balance",
}
export const LetPassAccountRequiredFieldList: string[] = [
    'companyCode',
    'paymentMode',
    'bankCode',
    'payOrderNo',
    'transactionAmount',
    'activeInd',
];